import React, { useEffect, useRef, useState } from 'react';
import { HelpCircleIcon, InfoIcon, LightbulbIcon } from 'lucide-react';
import { manualContent } from '../../Manualcontent';
interface HelpTooltipProps {
  moduleId: string;
}
export function HelpTooltip({
  moduleId
}: HelpTooltipProps) {
  const [isOpen, setIsOpen] = useState(false);
  const tooltipRef = useRef<HTMLDivElement>(null);
  const section = manualContent.find(item => item.id === moduleId);
  useEffect(() => {
    const handlePointerDown = (event: MouseEvent) => {
      if (tooltipRef.current && !tooltipRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handlePointerDown);
    return () => document.removeEventListener('mousedown', handlePointerDown);
  }, []);
  if (!section) return null;
  return <div className="relative inline-block" ref={tooltipRef} data-id="element-3768" data-mp="38w8jeojl5jae">
      <button type="button" onClick={() => setIsOpen(current => !current)} className="rounded-full p-1 text-gray-400 transition-colors hover:bg-teal-50 hover:text-teal-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-teal-500 dark:hover:bg-teal-500/10 dark:hover:text-teal-300" aria-expanded={isOpen} aria-label={`Ayuda sobre ${section.title}`} title="Ayuda sobre este módulo" data-id="element-3769" data-mp="343ywlhdrozcc">
        
        <HelpCircleIcon className="h-4 w-4" data-id="element-3770" data-mp="2oqshs0v6ih89" />
      </button>

      {isOpen && <div className="absolute right-0 top-7 z-50 w-[calc(100vw-2rem)] max-w-72 rounded-xl border border-gray-100 bg-white p-3.5 shadow-xl dark:border-white/10 dark:bg-gray-800" data-id="element-3771" data-mp="2arj4b8ycy17z">
          <p className="mb-1 text-sm font-semibold text-gray-800 dark:text-gray-100" data-id="element-3772" data-mp="20vzhrd5ooevw">{section.title}</p>
          <p className="mb-2 text-xs text-gray-500 dark:text-gray-400" data-id="element-3773" data-mp="25usn2iatgzkz">{section.summary}</p>
          {section.steps && section.steps.length > 0 && <ol className="mb-2 list-inside list-decimal space-y-1" data-id="element-3774" data-mp="42nztk49iqgl">
              {section.steps.slice(0, 4).map(step => <li key={step} className="text-xs text-gray-600 dark:text-gray-300" data-id="element-3775" data-mp="2m0fuyffp249">{step}</li>)}
            </ol>}
          {section.tips?.[0] && <div className="mb-1.5 flex items-start gap-1.5 rounded-lg bg-amber-50 p-2 text-[11px] text-amber-800 dark:bg-amber-500/10 dark:text-amber-300" data-id="element-3776" data-mp="3ttv2n0ovd64r">
              <LightbulbIcon className="mt-0.5 h-3.5 w-3.5 shrink-0" data-id="element-3777" data-mp="3ks5d60ejsh9m" />
              <span data-id="element-3778" data-mp="lbp5cc0inqc8">{section.tips[0]}</span>
            </div>}
          {section.notes?.[0] && <div className="flex items-start gap-1.5 rounded-lg bg-teal-50 p-2 text-[11px] text-teal-800 dark:bg-teal-500/10 dark:text-cyan-300" data-id="element-3779" data-mp="gd5kkexnsklg">
              <InfoIcon className="mt-0.5 h-3.5 w-3.5 shrink-0" data-id="element-3780" data-mp="bkm51cfevfe0" />
              <span data-id="element-3781" data-mp="7ldd8d3xlrl3">{section.notes[0]}</span>
            </div>}
        </div>}
    </div>;
}